export default "__VITE_ASSET__b7f38d90__"